import { Controller } from "@hotwired/stimulus";
import "react_ujs";

export default class extends Controller {
  static targets = ["productSelect"];
  static values = {
    roofingItemId: String,
    estimateId: String,
    duplicate: Boolean,
  };

  initialize() {
    const checkedRadio = this.productSelectTargets.find(
      (radio) => radio.checked
    );
    if (checkedRadio) {
      this.loadOptionsWithValue(checkedRadio.value);
    }
  }

  loadOptions(event) {
    const productId = event.target.value;
    this.loadOptionsWithValue(productId);
  }

  loadOptionsWithValue(productId) {
    if (productId) {
      const optionsFrame = document.getElementById("roofing_options");
      const params = new URLSearchParams();

      if (this.roofingItemIdValue) {
        params.append("roofing_item_id", this.roofingItemIdValue);
      }

      if (this.estimateIdValue) {
        params.append("estimate_id", this.estimateIdValue);
      }

      if (this.duplicateValue) {
        params.append("duplicate", "true");
      }

      optionsFrame.src = `/sales/roofing_products/${productId}/options?${params.toString()}`;

      // Reinitialize React components after Turbo frame loads
      optionsFrame.addEventListener(
        "turbo:frame-load",
        this.initializeReactComponents,
        { once: true }
      );
    }
  }

  initializeReactComponents() {
    ReactRailsUJS.handleMount();
  }
}
